import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

interface ITokenContent {
  id: string;
  tenantId: string;
  permissions: string[];
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  static AUTH_TOKEN_KEY = 'auth_token';

  tokenContent: ITokenContent | undefined;

  constructor() {}

  decodePermissions(accessToken: string) {
    this.tokenContent = jwtDecode(accessToken);
  }

  checkPermission(permissionName: string): boolean | undefined {
    return this.tokenContent?.permissions.includes(permissionName);
  }
}

enum NOTIFICATION {
  NOTIFICATION = 'NOTIFICATION'
}

enum MAP_EXPORT {
  PLOTTING = 'PLOTTING',
  EXPORT_DXF = 'EXPORT_DXF',
  PRINT = 'PRINT',
  ADVANCED_QUERY_EXPORT = 'ADVANCED_QUERY_EXPORT'
}

enum MAP_SIDEBAR {
  DRAWING_TOOL = 'SIDEBAR_DRAWING_TOOL',
  BOOKMARKS = 'SIDEBAR_BOOKMARKS',
  VISIBILITY_BOOKMARK = 'VISIBILITY_BOOKMARK',
  DYNAMIC_LAYERS = 'SIDEBAR_DYNAMIC_LAYERS',
  VISIBILITY_THIRDPARTY_LAYER = 'VISIBILITY_THIRDPARTY_LAYER',
  LAYERS_CONFIGURATOR = 'SIDEBAR_LAYERS_CONFIGURATOR',
  QUERY = 'SIDEBAR_QUERY',
  VISIBILITY_QUERY = 'VISIBILITY_QUERY',
  SHAPE_CONFIGURATOR = 'SIDEBAR_SHAPE_CONFIGURATOR',
  VISIBILITY_FILE_LAYER = 'VISIBILITY_FILE_LAYER',
  VALVE = 'SIDEBAR_VALVE',
  OTDR = 'SIDEBAR_OTDR',
  PSA = 'SIDEBAR_PSA',
  CONTROLLI = 'SIDEBAR_CONTROLLI',
  TRASMISSIONE_ANTEA = 'SIDEBAR_TRASMISSIONE_ANTEA',
  CHECKINOUT = 'SIDEBAR_CHECKINOUT',
  ANALISI_SCHIACCIAMENTI = 'SIDEBAR_ANALISI_SCHIACCIAMENTI',
  TRACING = 'SIDEBAR_TRACING',
  CHECKIN_ANALYSIS = 'SIDEBAR_CHECKIN_ANALYSIS',
  FIBER_JOINTS = 'SIDEBAR_FIBER_JOINTS',
  TOOL_FATTIBILITA = 'SIDEBAR_TOOL_FATTIBILITA',
}

enum MAP_SHAPE {
  ADD_SHAPE_LAYER = 'ADD_SHAPE_LAYER',
  DELETE_SHAPE_LAYER = 'DELETE_SHAPE_LAYER',
  EDIT_SHAPE_LAYER = 'EDIT_SHAPE_LAYER',
  ADD_LAYER_STYLE = 'ADD_LAYER_STYLE',
  UPDATE_LAYER_STYLE = 'UPDATE_LAYER_STYLE',
  DELETE_LAYER_STYLE = 'DELETE_LAYER_STYLE',
  FILE_LAYER_CSV = 'FILE_LAYER_CSV',
  FILE_LAYER_SHP = 'FILE_LAYER_SHP',
  FILE_LAYER_KML = 'FILE_LAYER_KML',
  FILE_LAYER_KMZ = 'FILE_LAYER_KMZ'
}

enum FIBER_JOINTS {
  RACCORDI_SALE_EDIT_WEB = 'RACCORDI_SALE_EDIT_WEB',
  RACCORDI_SALE_CREATE = 'RACCORDI_SALE_CREATE'
}

export const PERMISSION_NAME = {
  MAP: {
    SHAPE: MAP_SHAPE,
    SIDEBAR: MAP_SIDEBAR,
    ...MAP_EXPORT
  },
  FIBER_JOINTS: FIBER_JOINTS,
  NOTIFICATION: NOTIFICATION
};
